/**
 * Copyright Mántum All Rights Reserved.
 */
export const merge = <T, K>(before: T, after?: K) => ({
    ...before,
    ...after
});

export const isPlainObject = (value: unknown) => value?.constructor === Object;
